import {
    getClientOverview,
    getDomainProgress,
    getGoalsProgress,
    getGoalDrilldown,
    resetGoalDrilldown,
    resetClinicalAnalytics,
} from './clinicalAnalytics.action';

export { clinicalAnalyticsReducer } from './clinicalAnalytics.reducer';
export { watchClinicalAnalytics } from './clinicalAnalytics.saga';

export const clinicalAnalyticsActions = {
    getClientOverview,
    getDomainProgress,
    getGoalsProgress,
    getGoalDrilldown,
    resetGoalDrilldown,
    resetClinicalAnalytics,
};
